"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const libs_1 = require("./libs");
const react_1 = require("react");
function useTrackPageView(enumScreenName, withExtra = false, isDialog = false, timeout = 100) {
    (0, react_1.useEffect)(() => {
        (0, libs_1.trackPageView)(enumScreenName, isDialog, timeout);
    }, []);
}
exports.default = useTrackPageView;
